export default "__VITE_ASSET__Bk2hKoXp__"